import React from 'react'
import { TABLA_DETALLE_CARGA_DIARIA } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

function DetalleDeCargaDeBuqueView () {
  return (
    <MuiTable id={TABLA_DETALLE_CARGA_DIARIA} />
  )
}

export default DetalleDeCargaDeBuqueView
